<template>
  <div class="cropper-wrapper mb-5">
    <p class="mb-2">Upload Gambar</p>
    <!-- crpper -->
    <b-row v-if="!uploaded">
      <b-col cols="auto">
        <cropper
          v-if="image.src"
          ref="cropperComponent"
          class="cropper rounded-xl animated mb-3"
          :src="image.src"
          :stencil-props="{
            aspectRatio: 1,
          }"
          @change="onChangeCropper"
        />
        <b-progress
          :max="100"
          animated
          class="w-100 mb-3"
          variant="success"
          v-if="isUploading"
        >
          <b-progress-bar
            :value="uploadPercentage"
            :label="`${uploadPercentage}%`"
          ></b-progress-bar>
        </b-progress>
      </b-col>
      <b-col cols="auto">
        <cropper-preview
          v-if="image.src"
          class="rounded-xl animated"
          :width="120"
          :height="120"
          :image="result.image"
          :coordinates="result.coordinates"
        />
      </b-col>
    </b-row>
    <div v-else-if="uploaded && uploaded.url" class="animated d-flex">
      <b-img
        thumbnail
        fluid
        rounded="xl"
        :src="uploaded.url"
        alt="Uploaded Cropped Image"
        width="200"
      ></b-img>
      <div class="d-flex flex-column justify-content-center">
        <b-btn
          class="btn-icon mb-3"
          variant="light-danger"
          @click="uploaded = null"
          v-b-tooltip="'Crop ulang gambar'"
        >
          <i class="ri-arrow-go-back-line"></i>
        </b-btn>
        <b-btn
          class="btn-icon"
          variant="danger"
          @click="
            reset();
            uploaded = null;
          "
          v-b-tooltip="'Ambil ulang gambar'"
        >
          <i class="ri-delete-bin-2-line"></i>
        </b-btn>
      </div>
    </div>
    <b-row class="mx-0 mb-5">
      <!-- upload button -->
      <b-button
        v-if="!uploaded"
        class="button"
        @click="$refs.fileUploadCropper.click()"
        :disabled="isUploading"
      >
        <input
          type="file"
          ref="fileUploadCropper"
          @change="loadImage($event)"
          accept="image/*"
        />
        <i class="ri-image-add-line"></i>
        Ambil {{ image.src ? "Ulang" : "Gambar" }}
      </b-button>
      <!-- reset button -->
      <b-button
        v-if="image.src && !uploaded"
        class="btn-icon ml-2 animated"
        @click="reset"
        variant="light-danger"
        :disabled="isUploading"
      >
        <i class="ri-delete-back-2-line"></i
      ></b-button>
      <!-- upload button -->
      <b-button
        v-if="image.src && !uploaded"
        variant="success"
        class="ml-2 animated"
        @click="crop"
        :disabled="isUploading"
      >
        <i class="ri-gallery-upload-line"></i>
        Upload Gambar
      </b-button>
    </b-row>
  </div>
</template>

<script>
// This function is used to detect the actual image type,
function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = "";
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case "89504e47":
      return "image/png";
    case "47494638":
      return "image/gif";
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return "image/jpeg";
    default:
      return fallback;
  }
}

export default {
  name: "FePerpusCropperUpload",

  props: {
    directory: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      image: {
        src: null,
        type: null,
      },
      result: {
        coordinates: null,
        image: null,
      },
      uploaded: null,
      isUploading: false,
      uploadPercentage: 0,
    };
  },

  methods: {
    blobToFile(theBlob, fileName) {
      //A Blob() is almost a File() - it's just missing the two properties below which we will add
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    crop() {
      const { canvas } = this.$refs.cropperComponent.getResult();
      canvas.toBlob((blob) => {
        // Do something with blob: upload to a server, download and etc.
        let cropImage = this.blobToFile(
          blob,
          `CroppedImage.${this.image.type.split("/")[1]}`
        );
        var reader = new FileReader();
        reader.readAsDataURL(cropImage);

        this.uploadPercentage = 0;
        this.isUploading = true;
        this.$_api
          .fileUpload(cropImage, this.directory || null, (event) => {
            this.uploadPercentage = Math.round(
              (100 * event.loaded) / event.total
            );
          })
          .then((res) => {
            this.uploaded = res;
            this.$_alert.success("Berhasil upload gambar.");
          })
          .catch((err) => {
            console.log("crop fileUpload err", err);
            this.$_alert.error(err);
          })
          .finally(() => {
            this.isUploading = false;
            this.uploadPercentage = 0;
          });
      }, this.image.type);
    },
    onChangeCropper({ coordinates, image }) {
      this.result = {
        coordinates,
        image,
      };
    },
    reset() {
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(event) {
      // Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: getMimeType(e.target.result, files[0].type),
          };
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0]);
      }
    },
  },
  watch: {
    uploaded: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit("input", newVal);
        }
      },
    },
  },

  mounted() {},

  destroyed() {
    // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
};
</script>

<style lang="scss" scoped>
.cropper-wrapper {
  .cropper {
    max-width: 600px;
    max-height: 600px;
    border: 1px dashed #ddd;
    overflow: hidden;
  }

  input {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/base/component/cropper-upload.vue